import React, { Fragment } from "react";
import PropTypes from "proptypes";
import { formatDate } from "./../../../helpers/TripHelper";
import PaymentDetails from "./../../screens/UserProfile/PaymentDetails";
import moment from "moment";

const PastTrips = ({ pastTrips }) =>
  pastTrips && pastTrips.length ? (
    <div className="row past-trips" id="past-trips">
      <div className="col-md-12 padding-right">
        <h3 className="h1-style muted">Past Trips</h3>
        {pastTrips.map(trip => (
          <div className="row" key={trip.id}>
            <div
              className="col-md-12 no-padding-col"
              style={{ marginBottom: "10px" }}
            >
              {(trip.content.videoUrl || trip.content.imageUrl) &&
              trip.content.description ? (
                <div
                  className="col-md-4 padding-right"
                  style={{ marginBottom: "10px" }}
                >
                  {!trip.content.videoUrl ||
                  trip.content.videoUrl === undefined ? (
                    <img
                      className="trip-image"
                      src={`${trip.content.imageUrl}`}
                      alt={trip.destination}
                    />
                  ) : (
                    <div className="resp-container">
                      <iframe
                        id={trip.content.id}
                        className="resp-iframe"
                        title="add-on video"
                        frameBorder="0"
                        padding="0"
                        margin="0"
                        allowFullScreen
                        allow="autoplay; encrypted-media;"
                        src={trip.content.videoUrl.replace(
                          "youtu.be/",
                          "www.youtube.com/embed/"
                        )}
                      />
                    </div>
                  )}
                </div>
              ) : (
                ""
              )}
              <div
                className={`no-padding-col ${
                  trip.content.imageUrl || trip.content.videoUrl
                    ? "col-md-8"
                    : "col-md-12"
                }`}
              >
                <h4 className="muted inline">
                  {trip.destination},{" "}
                  {formatDate(
                    moment(trip.startDate, "MMMM Do, YYYY"),
                    moment(trip.endDate, "MMMM Do, YYYY")
                  )}
                </h4>
                <span className="tag">{trip.stageName}</span>
                <p className="trip-description">{trip.content.description}</p>
              </div>
            </div>
            {trip.stageName === "Canceled" && trip.payments && trip.payments.tripAmount !== trip.payments.tripBalance ? (
                <Fragment>
                  <h5 className="muted">Payment Details</h5>
                  <PaymentDetails
                    trip={trip}
                  />
                </Fragment>
              ) : (
                ""
              )
            }
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );

PastTrips.propTypes = {
  pastTrips: PropTypes.arrayOf(
    PropTypes.shape({
      destination: PropTypes.string,
      endDate: PropTypes.string,
      content: PropTypes.shape({
        imageUrl: PropTypes.string,
        videoUrl: PropTypes.string,
        description: PropTypes.string
      })
    })
  ).isRequired
};

export default PastTrips;
